// extracted by mini-css-extract-plugin
export default {"wrap":"Layout-module--wrap--55f33","body":"Layout-module--body--7a612"};